import fp from 'lodash/fp';
import { combineActions, handleActions } from 'redux-actions';
import { updateIn } from '../../../../utils';
import { actions } from './actions';

export const initialState = {
  content: {
    contentResult: {
      content: [],
      total: 0,
      hits: 0,
      take: 0,
      skip: 0
    },
    contentQuestions: [],
    contentPassedUserEmails: [],
    selectedContent: null,
    isFetching: false,
    isLoadingMore: false,
    saveQuestionSuccess: false,
    error: null
  }
}

const extendStateContent = (state, newState) => ({
  ...state,
  content: {
    ...state.content,
    ...newState
  }
});

export const reducerDefinition = {
  [actions.business.content.api.get.request]: (state, action) =>
    extendStateContent(state, {
      isFetching: true
    }),
  [actions.business.content.api.get.success]: (state, action) =>
    extendStateContent(state, {
      isFetching: false,
      contentResult: action.payload.contentResult,
      error: null
    }),
  [actions.business.content.api.getNonCpdContent.success]: (state, action) =>
    extendStateContent(state, {
      nonCpdContent: action.payload.content
    }),
  [actions.business.content.api.getById.success]: (state, action) =>
    extendStateContent(state, {
      isFetching: false,
      selectedContent: action.payload.content
    }),
  [actions.business.content.resetSelectedContent]: (state, action) =>
    extendStateContent(state, {
      selectedContent: null
    }),
  [combineActions(
    actions.business.content.api.addContent.request,
    actions.business.content.api.updateContent.request)]: (state, action) =>
      extendStateContent(state, {
        isFetching: true,
        error: null
      }),
  [actions.business.content.api.addContent.success]: (state, action) =>
    extendStateContent(state, {
      isFetching: false,
      lastSavedContentType: action.payload.content.contentType,
      error: null
    }),
  [combineActions(
    actions.business.content.api.getById.failed,
    actions.business.content.api.addContent.failed,
    actions.business.content.api.updateContent.failed)]: (state, action) =>
      extendStateContent(state, {
        isFetching: false,
        error: action.payload.error
      }),
  [actions.business.content.api.loadMore.request]: (state, action) =>
    extendStateContent(state, {
      isFetching: true,
      isLoadingMore: true
    }),
  [actions.business.content.api.loadMore.success]: (state, action) => {
    const { contentResult } = action.payload;
    const content = fp.concat(state.content.contentResult.content, contentResult.content);

    return extendStateContent(state, {
      isFetching: false,
      isLoadingMore: false,
      contentResult: {
        ...contentResult,
        content
      },
      error: null
    });
  },
  [combineActions(actions.business.content.api.get.failed,
    actions.business.content.api.loadMore.failed)]: (state, action) =>
      extendStateContent(state, {
        isFetching: false,
        isLoadingMore: false,
        error: action.payload.error
      }),
  [combineActions(actions.business.content.api.addQuestion.request,
    actions.business.content.api.updateQuestion.request,
    actions.business.content.api.deleteQuestion.request)]: (state, action) =>
      extendStateContent(state, {
        saveQuestionSuccess: false,
        error: null
      }),
  [actions.business.content.api.addQuestion.success]: (state, action) =>
    extendStateContent(state, {
      saveQuestionSuccess: true,
      contentQuestions: fp.concat(state.content.contentQuestions)(action.payload.question),
      error: null
    }),
  [actions.business.content.api.updateQuestion.success]: (state, action) =>
    extendStateContent(state, {
      saveQuestionSuccess: true,
      contentQuestions: updateIn(state.content.contentQuestions, action.payload.question, 'id'),
      error: null
    }),
  [actions.business.content.api.deleteQuestion.success]: (state, action) =>
    extendStateContent(state, {
      contentQuestions: fp.filter((q) => q.id !== action.payload.deleted.id)(state.content.contentQuestions),
      error: null
    }),
  [combineActions(actions.business.content.api.addQuestion.failed,
    actions.business.content.api.updateQuestion.failed)]: (state, action) =>
      extendStateContent(state, {
        saveQuestionSuccess: false,
        error: 'Question did not add for the content, Please try again.'
      }),
  [actions.business.content.api.getContentQuestions.success]: (state, action) =>
    extendStateContent(state, {
      contentQuestions: action.payload.questions || []
    }),    
  [actions.business.content.api.getContentPassedUserEmails.success]: (state, action) =>
    extendStateContent(state, {
      contentPassedUserEmails: action.payload.passedUserEmails || []
    }),

}

export default handleActions(reducerDefinition, { ...initialState });


// WEBPACK FOOTER //
// ./src/state/modules/business/content/reducers.js